import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "leadingmodel"
    }}>{`LeadingModel`}</h1>
    <p>{`Leading model options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEADING_MODEL_ROMAN`}</strong>{` = 1248619858`}</p>
      <p parentName="blockquote">{`Measures the space between type baselines.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEADING_MODEL_AKI_BELOW`}</strong>{` = 1248616802`}</p>
      <p parentName="blockquote">{`Measures the space between lines from the aki below.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEADING_MODEL_AKI_ABOVE`}</strong>{` = 1248616801`}</p>
      <p parentName="blockquote">{`Measures the space between lines from the aki above.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEADING_MODEL_CENTER`}</strong>{` = 1248619875`}</p>
      <p parentName="blockquote">{`Measures the space between the character center points.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEADING_MODEL_CENTER_DOWN`}</strong>{` = 1248617316`}</p>
      <p parentName="blockquote">{`Center down leading model.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      